var _path, _path2, _path3, _path4, _line, _path5, _path6, _path7, _g, _ellipse, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 470,
    viewBox: "0 0 528 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 101C78.9227 117.524 86.5973 113.051 90.3666 138.722L126.438 414.038",
    stroke: "#FB9CAD",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0002 171H426.5L376.5 343L125 373.5",
    stroke: "#FB9CAD",
    strokeWidth: 15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 435.5C170.5 449.653 158.621 461.5 143.5 461.5C128.379 461.5 116.5 449.653 116.5 435.5C116.5 421.347 128.379 409.5 143.5 409.5C158.621 409.5 170.5 421.347 170.5 435.5Z",
    stroke: "#FB9CAD",
    strokeWidth: 15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M370.5 436.5C370.5 450.653 358.621 462.5 343.5 462.5C328.379 462.5 316.5 450.653 316.5 436.5C316.5 422.347 328.379 410.5 343.5 410.5C358.621 410.5 370.5 422.347 370.5 436.5Z",
    stroke: "#FB9CAD",
    strokeWidth: 15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 167.951,
    y1: 437.5,
    x2: 318.951,
    y2: 436.5,
    stroke: "#FB9CAD",
    strokeWidth: 15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395 69.0003C393.372 120.197 257.719 256.383 213.5 184.727C213.5 161 202.897 140.861 233.5 118.5C283.933 81.6487 324.984 141.918 319.5 184.727C313.44 232.039 176.45 295.239 171.5 289.5",
    stroke: "#FB9CAD",
    strokeWidth: 5,
    strokeDasharray: "20 10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M401.446 8.73342L409.306 23.8704L395.676 23.8704C391.704 24.7047 385.83 24.3878 383.882 20.6274C381.933 16.8668 383.239 13.5788 387.211 12.7444C385.004 9.04607 387.698 5.11935 390.159 4.09182C392.62 3.06428 383.882 4.09192 383.882 4.09192C387.144 1.73276 399.015 4.53312 401.446 8.73342Z",
    fill: "#C8E5E7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_52",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 399,
    y: 8,
    width: 38,
    height: 43
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M432.775 40.3597C426.264 49.2344 413.534 53.2224 405.431 49.0021C400.537 46.136 397.723 31.9773 401.863 21.691C405.431 12.8244 414.682 5.04006 424.94 10.1287C436.05 13.384 439.285 31.485 432.775 40.3597Z",
    fill: "#FBE28A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.775 40.3597C426.264 49.2344 413.534 53.2224 405.431 49.0021C400.537 46.136 397.723 31.9773 401.863 21.691C405.431 12.8244 414.682 5.04006 424.94 10.1287C436.05 13.384 439.285 31.485 432.775 40.3597Z",
    fill: "#FBE28A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.324 8.56824C416.819 22.5296 425.812 28.1501 443.482 35.6394L438.602 44.2539C418.793 36.8345 409.777 31.0559 398.444 17.1827L403.324 8.56824Z",
    fill: "#151313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.444 22.6404C411.938 36.6018 420.932 42.2223 438.602 49.7116L433.041 57.5147C413.232 50.0953 404.216 44.3167 392.883 30.4435L398.444 22.6404Z",
    fill: "#151313"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.64,
    cy: 16.3713,
    rx: 1.30062,
    ry: 1.41874,
    fill: "#232121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M495.5 257.5V256.848L495.265 256.24C493.575 251.858 494.676 247.911 497.431 245.154C500.255 242.328 505.067 240.551 510.967 241.459L511.232 241.5H511.5C518.582 241.5 524.5 247.445 524.5 255C524.5 262.555 518.582 268.5 511.5 268.5C507.527 268.5 503.341 267.371 500.253 265.345C497.222 263.356 495.5 260.714 495.5 257.5Z",
    stroke: "#FDDBE1",
    strokeWidth: 7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M334.329 -4.78547e-05C332.148 5.64729 329.924 7.455 324 8.06714C330.146 12.2959 331.884 14.7539 332.742 19.2612C334.838 13.5689 337.23 11.9754 343.072 11.194C337.902 8.96596 335.899 6.64788 334.329 -4.78547e-05Z",
    fill: "#FDDBE1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1266 323.814C21.3955 338.641 15.5554 343.389 0 345C16.1324 356.097 20.6937 362.548 22.9453 374.38C28.451 359.435 34.7337 355.25 50.0719 353.194C36.5 347.349 31.2428 341.265 27.1266 323.814Z",
    fill: "#FDDBE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.ca620975e405825aca80389ffd209e87.svg";
export { ForwardRef as ReactComponent };